var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "i-facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer-quick-link_1024-nomenu",
    transform: "translate(-661.000000, -170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social-icons-copy",
    transform: "translate(661.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i-facebook"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.557582,27.7878579 L20.557582,20.3930632 L22.5852474,20.3930632 L22.8539569,17.8447759 L20.557582,17.8447759 L20.561027,16.5693337 C20.561027,15.9047011 20.6237546,15.5485758 21.5719889,15.5485758 L22.8396027,15.5485758 L22.8396027,13 L20.8116503,13 C18.3757532,13 17.5183806,14.2361935 17.5183806,16.3150821 L17.5183806,17.8450645 L16,17.8450645 L16,20.3933518 L17.5183806,20.3933518 L17.5183806,27.7878579 L20.557582,27.7878579 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#FFFFFF",
    opacity: 0.1,
    cx: 19.8665414,
    cy: 20,
    rx: 19.8665414,
    ry: 20
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.2a1fe090dd2e43959fa1c0c38ff03084.svg";
export { ForwardRef as ReactComponent };